export const format = (str: string, args: any[]) =>
    str.replace(/{(\d+)}/g, (match, index) => typeof args[index] !== 'undefined' ? args[index] : match);

